<template>
  <div class="modal-wrap">
    <div class="modal-header">
      <p class="mb-15 bold" v-show="!this.isEditing">Lägg till ny kund på visning</p>
      <p class="mb-15 bold" v-show="this.isEditing">Redigera {{firstName + ' ' + lastName}}</p>
    </div>
    <div class="modal-content">
      <div class="modal animate__animated animate__fadeInUp width-100">
        <input type="tel" class="width-100 mb-15" v-model="cellphone" placeholder="Mobilnummer" @blur="matchCustomer">

        <div class="grid2col mb-15 width-100">
          <input type="text" v-model="firstName" placeholder="Förnamn" class="width-100">
          <input type="text" v-model="lastName" placeholder="Efternamn" class="width-100">
        </div>

        <input type="email" class="width-100 mb-15" v-model="email" placeholder="E-post" @blur="matchCustomer">

        <template v-if="!isEditing && !selected">
          <div class="flex justify-between mb-20 align-middle">
            <span>Dubblettkontroll</span>
            <div style="width: 200px;" class="mr-5">
              <p v-show="customerMatched === 0" class="discreet text-right">Ingen matchning</p>
              <p v-show="customerMatched > 0" class="discreet text-right">{{customerMatched + " kund matchar"}}</p>
            </div>
          </div>

          <template v-if="customers.length > 0">
            <customerMatch v-for="customer in customers" :customer="customer" v-bind:key="customer.id" :addCustomerData="updateCustomerFormWithMatchedCustomer"></customerMatch>
          </template>
        </template>



        <div class="flex justify-between mb-20 align-middle">
          <span>Har lånelöfte</span>
          <div style="width: 200px;" class="mr-5">
            <select class="discreet text-right" v-model="loanCommitment">
              <option selected value="0">Vet ej</option>
              <option value="1">Ja</option>
              <option value="2">Nej</option>
              <option value="3">Kontant</option>
            </select>
          </div>
        </div>

        <div class="flex justify-between mb-15" v-show="!this.isEditing">
          <span>Skicka information om datapolicy</span>
          <label class="switch mr-10" style="width: 33px;">
            <input type="checkbox" class="mr-5" v-model="dataPolicy">
            <div class="slider round"></div>
          </label>
        </div>

      </div>
    </div>

    <div class="modal-buttons">
      <div class="grid2col">
        <button class="width-100 fg-black" @click="abortForm">
          avbryt
        </button>
        <button class="width-100" @click="save">
          spara
        </button>
      </div>
    </div>
    <spinner v-show="loading"/>
  </div>
</template>

<script>
import spinner from '../../spinner';
import customerMatch from '../../showing/CustomerMatch';
import Bugsnag from '@bugsnag/js';

export default {
  name: 'customerForm',
  data(){
    return {
      customerId: null,
      firstName: '',
      lastName: '',
      email: '',
      cellphone: '',
      loanCommitment: 0,
      dataPolicy: 0,
      loading: false,
      isEditing: false,
      customerMatched: 0,
      customers: [],
      selected: false
    }
  },
  components: {
    spinner,
    customerMatch
  },
  methods: {
    resetCustomerForm() {
      this.customerId     = null;
      this.firstName      = '';
      this.lastName       = '';
      this.email          = '';
      this.cellphone      = '';
      this.loanCommitment = 0;
      this.dataPolicy     = 0;
      this.selected       = false;
      this.customers      = [];
    },
    save() {
      if (
          !this.firstName.length ||
          !this.lastName.length ||
          !this.cellphone.length
      ) {
        alert("Alla fält är inte ifyllda, vänligen fyll i alla fält och försök igen.");
        return;
      }
      this.loading = true;
      let data = {
        fkcustomer: this.customerId,
        objectId: this.$route.params.id,
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        cellphone: this.cellphone,
        managedBy: this.$store.state.showing.currentListingWithActiveShowing.realtor.id,
        loanCommitment: this.loanCommitment,
        dataPolicy: this.dataPolicy,
        objectShowing: this.$store.state.showing.currentShowingsSlot.objectShowingId,
        intervalNumber: this.$store.state.showing.currentShowingsSlot.intervalNumber
      }

      let endpoint = "/internalapi/customer/add-customer";
      if (this.isEditing) {
        endpoint = "/internalapi/customer/update-customer";
        data.id = this.customerId;
      }

      this.$root.callFasAdApi(endpoint, 'POST', data)
      .then((data) => {
        this.$root.handleResponseMessage(data);

        // refresh data
        this.$store.dispatch('showing/storeShowingDataForSelectedListing', { listingId: this.$route.params.id });
        // reset the  form
        if (!this.isEditing) {
          this.resetCustomerForm();
        }
        this.abortForm();
        this.loading         = false;
        this.$root.modalOpen = false;
      })
      .catch((error) => {
        Bugsnag.notify(error);
        Bugsnag.notify(data);
      });
    },
    matchCustomer() {
      if (!this.isEditing && (this.cellphone.length || this.email.length)) {
        let phoneNumber = '';
        if (this.cellphone.length) {
          phoneNumber = this.cellphone.replace('0', '46');
        }

        let data = {
          cellphone: phoneNumber,
          mail: this.email,
        };

        let url = "/internalapi/customer/match-customer?";
        let size = Object.keys(data).length;
        Object.keys(data).forEach(function ( key, idx ) {
          url = url.concat(key + '=' + encodeURIComponent(data[key]));
          if (idx !== (size - 1)) {
            url = url.concat('&');
          }
        });

        this.$root.callFasAdApi(url).then((response) => {
          if (response.data == null){
            this.customerMatched = 0;
            this.customers = [];
            return false;
          }

          let resultNumber = response.data.length;
          if (resultNumber > 0){
            this.customers = response.data
            this.customerMatched = resultNumber;
          }
        })
        .catch((error) => {
          Bugsnag.notify(error);
          Bugsnag.notify(data);
        });
      }
    },
    abortForm() {
      this.$root.abortForm();
      this.$store.commit('showing/STORE_CURRENT_CUSTOMER', null);
    },
    updateCustomerFormWithMatchedCustomer(customer) {
      this.customerId = customer.id;
      this.firstName = customer.firstname;
      this.lastName = customer.lastname;
      this.email = customer.email;
      this.cellphone = customer.cellphone;
      this.loanCommitment = customer.loancommitment || 0;
      this.selected = true;
    },
  },
  created() {
    if (this.$store.state.showing.currentCustomer !== null) {
      this.isEditing = true;
      this.firstName = this.$store.state.showing.currentCustomer.firstname;
      this.customerId = this.$store.state.showing.currentCustomer.id;
      this.lastName = this.$store.state.showing.currentCustomer.lastname;
      this.email = this.$store.state.showing.currentCustomer.email || this.$store.state.showing.currentCustomer.mail;
      this.cellphone = this.$store.state.showing.currentCustomer.cellphone;
      this.loanCommitment = this.$store.state.showing.currentCustomer.loancommitment || 0;
    }
    this.$store.commit('showing/STORE_CURRENT_CUSTOMER', null);
  },
}
</script>
